const ADD_TAG_TABLE = 'add_tag_table';
const REVIEW_TAGS = 'review_tags';

const ADD_TAG_STEPS = {
  ADD_TAG_TABLE: ADD_TAG_TABLE,
  REVIEW_TAGS: REVIEW_TAGS
};
export { ADD_TAG_STEPS };
